module.exports = __webpack_public_path__ + "img/RedteaMobile_ picture2 web.280d092b.png";